import { TrainingRouter } from './TrainingRouter';
import EventsRouter from './components/eventProvider/EventsRouter';
import AuthErrorPage from './components/eventProvider/common/AuthErrorPage';
import RedirectPage from './components/eventProvider/common/RedirectPage';
import LoadingOverlay from './components/global/overlays/loading/LoadingOverlay';
import { CommContextProvider } from './hoc/CommContext';
import Store from './redux/store';
import { Provider } from 'react-redux';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';

export const App = () => {
  return <Router />;
};

export default App;

const Router = () => {
  return (
    <CommContextProvider>
      <Provider store={Store}>
        <LoadingOverlay />
        <BrowserRouter>
          <Routes>
            <Route path='/events/*' element={<EventsRouter />} />
            <Route path='/' element={<></>} />
            <Route path='/*' element={<Navigate to='/' />} />
          </Routes>
        </BrowserRouter>
      </Provider>
    </CommContextProvider>
  );
};
